import React, { useEffect, useRef, useState } from "react";
import Play from "../../assets/img/play.png";
import Pause from "../../assets/img/pause.png";

const PowerMode = ({ qns, dictionary }) => {
  const [inputValues, setInputValues] = useState({});

  useEffect(() => {
    // Parse dictionary and pre-fill inputs based on word IDs
    const parseDictionary = () => {
      console.warn(`Skipping invalid entry: ${typeof dictionary}`);

      if (dictionary === null) {
        console.warn(
          "Dictionary is empty, null, undefined, invalid, or not a string. Skipping parsing."
        );
        return;
      }
      const parsedValues = {};

      try {
        Object.entries(dictionary).forEach(([key, value]) => {
          console.log(`Key: ${key}, Value: ${value}`);
          if (!key || !value) {
            console.warn(`Skipping invalid entry: ${key}`);
            return;
          }

          const parts = key.trim().split("|");
          if (parts.length >= 2) {
            const wordId = parts[1].trim(); // Extract the wordId
            const inputAnswer = value.trim().replace(/['"]/g, ""); // Remove surrounding quotes
            if (wordId && inputAnswer) {
              parsedValues[wordId] = inputAnswer; // Map wordId to the input answer
            }
          }
        });

       

        // dictionary.forEach((entry) => {
        //   const [key, value] = entry.split(":");
        //   if (!key || !value) {
        //     console.warn(`Skipping invalid entry: ${entry}`);
        //     return;
        //   }

        //   const parts = key.trim().split("|");
        //   if (parts.length >= 2) {
        //     const wordId = parts[1].trim(); // Extract the wordId
        //     const inputAnswer = value.trim().replace(/['"]/g, ""); // Remove surrounding quotes
        //     if (wordId && inputAnswer) {
        //       parsedValues[wordId] = inputAnswer; // Map wordId to the input answer
        //     }
        //   }
        // });
      } catch (error) {
        console.error("Error parsing dictionary:", error);
      } // Populate input values
    };

    parseDictionary();
  }, [dictionary]);

  const getSpecialCharacters = (inputString) => {
    const specialCharacterRegex = /[^a-zA-Z0-9\s]/g;
    const specialCharactersArray = inputString.match(specialCharacterRegex);
    return specialCharactersArray ? specialCharactersArray.join("") : "";
  };

  const checkInputValidations = (spelling, actualWord) => {
    const specialCharacters = getSpecialCharacters(actualWord);
    const lastChar = spelling.slice(-1);
    if (!specialCharacters.includes(lastChar)) {
      return spelling.slice(0, -1) + lastChar.replace(/[^A-Za-z]/g, "");
    }
    return spelling;
  };

  const handleChange = (event, id, actualWord) => {
    const newValue = event.target.value;
    const validatedValue = checkInputValidations(newValue, actualWord);
    setInputValues((prev) => ({ ...prev, [id]: validatedValue }));
  };

  return (
    <div>
      <h1>All Questions</h1>
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #ddd",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Play
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Answer
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>POS</th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Definition
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Etymology
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Sentence
              </th>
            </tr>
          </thead>
          <tbody>
            {qns.map((question, index) => (
              <tr key={index}>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {question.QuizType === 1 && (
                    <PowerModePlayer audioUrl={question.audio} />
                  )}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  <input
                    type="text"
                    spellCheck="false"
                    style={{ width: "100%", padding: "5px" }}
                    value={inputValues[question.Id] || ""}
                    onChange={(e) =>
                      handleChange(e, question.Id, question.utfascii || "")
                    }
                    placeholder="Enter Spelling"
                  />
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {question.pos || "N/A"}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {question.Quizdefn || "N/A"}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {question.Quizetym || "N/A"}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                  {question.Quizsent || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const PowerModePlayer = ({ audioUrl }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((e) => {
        console.error("Error playing audio:", e);
      });
    }
  };

  const pauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      pauseAudio();
    } else {
      playAudio();
    }
  };

  useEffect(() => {
    const audioElement = audioRef.current;

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);
    const handleEnded = () => setIsPlaying(false);

    if (audioElement) {
      audioElement.addEventListener("play", handlePlay);
      audioElement.addEventListener("pause", handlePause);
      audioElement.addEventListener("ended", handleEnded);
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener("play", handlePlay);
        audioElement.removeEventListener("pause", handlePause);
        audioElement.removeEventListener("ended", handleEnded);
      }
    };
  }, []);

  const formatAudioUrl = (url) => {
    if (!url) return "";
    const mp3 = url.replace(/^sound:\/\//, ""); // Replace "sound://" with an empty string
    return `https://s3nsoftware.com/${mp3}`; // Construct the full URL
  };

  const iconStyle = {
    cursor: "pointer",
    height: "30px",
    width: "30px",
    opacity: 0.9,
  };

  return (
    <>
      <audio ref={audioRef} src={formatAudioUrl(audioUrl)} preload="auto" />
      <div id="play-button" style={{ display: "inline-block" }}>
        {isPlaying ? (
          <img
            style={iconStyle}
            src={Pause}
            onClick={togglePlayPause}
            alt="Pause"
          />
        ) : (
          <img
            style={iconStyle}
            src={Play}
            onClick={togglePlayPause}
            alt="Play"
          />
        )}
      </div>
    </>
  );
};

export default PowerMode;
